// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"381":"abe1506f","523":"c3c9075f"}[chunkId] + ".chunk.css";
};